import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, Router, RouterStateSnapshot} from '@angular/router';
import {from, Observable, of, switchMap, tap} from 'rxjs';
import {NavController} from "@ionic/angular/standalone";
import {AutocloseOverlaysService} from "../services/autoclose-overlay.service";


@Injectable({
  providedIn: 'root'
})
export class ModalGuard {
  /**
   * Constructor
   */
  constructor(
    private _router: Router,
    private autocloseOverlaysService: AutocloseOverlaysService,
  ) {
  }


  canDeactivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    return this._check(route, state);
  }

  private _check(childRoute?: ActivatedRouteSnapshot, state?: RouterStateSnapshot): Observable<boolean> {
    const navState = this._router?.getCurrentNavigation()?.extras?.state;
    console.log('state extras', navState);
    console.log('router', this._router);

    // Bypass guard when redirecting due to session expiration
    if (navState?.['sessionExpired']) {
      return of(true);
    }

    return from(this.autocloseOverlaysService.trigger(navState)).pipe(
      switchMap((value) => {
          return of(!value)
        }
      ),
      tap(() => {
        if (!!navState?.['skip']) {
          this._router.getCurrentNavigation()!.extras.state =
            {...this._router.getCurrentNavigation()!.extras.state, skip: false};
        }
      }),
    )
  }
}
